import { service } from '../api/axios';

export const getLibraryFiles = () =>
  service
    .get<
      {
        _id: string;
        collectionName: string;
        title: string;
        isPrivate: boolean;
        fileUrl: string;
        owner: {
          _id: string;
          firstName: string;
          lastName: string;
          email: string;
          imageUrl: string;
          role: string;
          description: string;
          status: string;
          branch: string;
        };
        category: string;
        subject: string;
        createdAt: string;
        updatedAt: string;
        branch: string;
      }[]
    >(`/library`)
    .then((responseFromAPI) => responseFromAPI.data);

export const getFile = (fileId: string) =>
  service
    .get(`/library/${fileId}`)
    .then((responseFromAPI) => responseFromAPI.data);

export const getUserLibraryFiles = () =>
  service.get(`/library-user`).then((responseFromAPI) => responseFromAPI.data);

export const addFile = (
  title: string,
  category: string,
  subject: string,
  fileUrl: File,
  isPrivate: boolean,
  branch: string
) => {
  const data = new FormData();
  data.append('file', fileUrl);
  data.append('title', title);
  data.append('category', category);
  data.append('subject', subject);
  data.append('isPrivate', `${isPrivate}`);
  data.append('branch', branch);
  return service
    .post(`/library/add-file`, data)
    .then((responseFromAPI) => responseFromAPI.data);
};

export const uploadFileNoLibrary = async (file: any) => {
  const data = new FormData();
  data.append('file', file);
  const response = await service.post(`/file-upload-no-library`, data);
  return response.data;
};

export const deleteFileById = (fileId: string) =>
  service.put('/library-delete', { fileId }).then((fileDeleted) => fileDeleted);
